import React from 'react';
import Connector, { PropsFromRedux } from './Connector';
import { CUSTOMER_FEATURE_SETTINGS } from 'src/routes/Customers/modules/types';

type Props = PropsFromRedux & {
  children: React.ReactNode;
  featureName: CUSTOMER_FEATURE_SETTINGS;
};

const FeatureFlag = ({ featureAvailable, children }: Props) => {
  if (featureAvailable) {
    return <>{children}</>;
  }

  return null;
};

export default Connector(FeatureFlag);
